import React, { createContext, useState, useEffect } from 'react';
import axios from 'axios';
import { BASE_URL } from '../Globalapi/Globalapi';

const StudentContext = createContext();

const StudentProvider = ({ children }) => {
    const [students, setStudents] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const school_id = sessionStorage.getItem('school_id')
    const fetchStudents = async () => {
        try {
            

            const jwt = sessionStorage.getItem('jwt');
            const response = await axios.get(`${BASE_URL}/admin/student/list_all_student.php?school_id=${school_id}`, {
                headers: {
                    'Authorization': `Bearer ${jwt}`
                }
            });
            console.log('====================================');
            console.log(response);
            console.log('====================================');
            setStudents(response.data.data || []);
            // console("view data",response.message)
        } catch (error) {
            console.error('Error fetching students:', error);
            setError('Error fetching students');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchStudents();

    }, []);

    // Function to refresh the student list
    const refreshStudents = async () => {
        setLoading(true);
        await fetchStudents();
    };

    return (
        <StudentContext.Provider value={{ students, loading, error, refreshStudents }}>
            {children}
        </StudentContext.Provider>
    );
};

export { StudentProvider, StudentContext };
